<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row v-if="formData">
                <b-col cols="12">
                    <ValidationProvider name="coop_cv_name" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('coop_cv_name')">
                            <b-form-input v-model="formData.name" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>

                <b-col cols="12">
                    <b-form-group :label="$t('coop_cv_file')">
                        <div v-if="currentFileName" class="mb-2 text-muted small">
                            {{ $t('current_file') }}: <strong>{{ currentFileName }}</strong>
                        </div>
                        <b-form-file v-model="newFile" accept=".pdf,.doc,.docx" />
                    </b-form-group>
                </b-col>

                <b-col cols="12">
                    <ValidationProvider name="label" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('label')">
                            <parameter-selectbox v-model="formData.tag"
                                                 code="cv.tags"
                                                 :validate-error="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
            <div class="d-flex justify-content-center mt-3">
                <b-button variant="primary" :disabled="formLoading" @click="updateForm">
                    {{ $t('save') }}
                </b-button>
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
    import { ValidationObserver, ValidationProvider } from 'vee-validate';
    import CoopCvService from '@/services/CoopCvService';
    import ParameterSelectbox from '@/components/interactive-fields/ParameterSelectbox';

    export default {
        components: {
            ValidationProvider,
            ValidationObserver,
            ParameterSelectbox
        },
        props: {
            formId: {
                type: [Number, String],
                required: true
            }
        },
        data() {
            return {
                formLoading: false,
                formData: null,
                newFile: null
            };
        },
        computed: {
            currentFileName() {
                if (!this.formData) return '';
                return this.formData.file_name || this.formData.fileName || '';
            }
        },
        created() {
            this.getCV();
        },
        methods: {
            getCV() {
                CoopCvService.get(this.formId).then(response => {
                    const data = response.data.data || response.data;
                    if (data) {
                        if (!data.tag && Array.isArray(data.tags) && data.tags.length > 0) {
                            data.tag = data.tags[0];
                        }
                    }
                    this.formData = data;
                });
            },
            async updateForm() {
                const isValid = await this.$refs.formModalValidate.validate();

                if (isValid) {
                    this.formLoading = true;

                    const formData = new FormData();
                    formData.append('name', this.formData.name);
                    if (this.formData.tag) {
                        formData.append('tag', this.formData.tag);
                    }
                    if (this.newFile) {
                        formData.append('file', this.newFile);
                    }

                    CoopCvService.update(this.formId, formData)
                        .then(response => {
                            this.$toast.success(this.$t('api.' + response.data.message));
                            this.$emit('updateFormSuccess', true);
                        })
                        .catch((error) => {
                            this.showErrors(error, this.$refs.formModalValidate);
                        })
                        .finally(() => {
                            this.formLoading = false;
                        });
                }
            }
        }
    };
</script>
